<template>
    <div class="background justify-content-center align-items-center">
        <div class="align-items-center justify-content-center boxao">
            <div class="box-left">
                <h2>MANUTENÇÃO</h2>
                <p>
                    Estamos atualizando para a nova versão do "{{app_name}}". Neste momento estamos trabalhando para atualizar as novidades e facilidades para os usuários.
                </p>
                <p>
                    Nas próximas horas você poderá acessar novamente seu sistema {{app_name}}.
                </p>
            </div>
            <div class="box-right">
                <img width="290px" :src="logo_url" alt="logo">
            </div>
            <div class="img-mobile">
                <img width="200px" :src="logo_url" alt="logo">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InformationPage",
        data:function () {
            return{
            }
        },
        computed: {
            app_name: function () {
                return process.env.VUE_APP_NAME;
            },
            logo_url: function () {
                return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
            },
        },
    }
</script>

<style scoped>
    .background{
        padding: 0;
        margin: 0;
        background-size: cover;
        background: #eeeeee;
        /*background-image: url("../../assets/imgs/teste02.png");*/
        width: 100%;
        height: 100vh;
        display: flex;
    }

    .boxao{
        width: 80%;
        display: flex;
    }

    .box-left{
        text-align: left;
    }

    .box-right{
        text-align: right;
    }

    .box-left, .box-right{
        width: 350px;
    }

    h2{
        font-family: Roboto-Black;
        color: #595959;
        font-size: 36px;
        margin: 30px 0;
    }

    p{
        font-size: 14px;
        color: #000000;
        font-family: Roboto-Regular;
        margin: 30px 0
    }

    p.message{
        font-family: Roboto-Light;
    }

    .img-mobile{
        display: none;
    }

    @media only screen and (max-width: 500px) {
        .boxao{
            padding: 30px;
            display: block;
        }

        .boxao,.box-left, .box-right{
            width: 100%;
        }

        .box-right{
            display: none;
        }

        .img-mobile{
            display: block;
        }

        h2{
            font-size: 32px;
        }
    }

    @media only screen and (max-width: 500px) {
        .background {
            background-image: url("../../assets/imgs/bg02-mobile.png");
            display: block;
        }

    }

    @media only screen and (min-width: 501px) {
        .background {
            background-image: url("../../assets/imgs/teste02.png");
        }
    }


</style>
